import React from "react";

const Footer = () => {
  return <p className="footer">Designed & Coded by Ebraj🐱‍.</p>;
};

export default Footer;
